
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"2","y":"2","width":"7","height":"7","rx":"1"}}),_c('rect',{attrs:{"x":"2","y":"2","width":"7","height":"7","rx":"1","stroke":"#8F7A61","stroke-width":"1.5"}}),_c('rect',{attrs:{"x":"7","y":"7","width":"7","height":"7","rx":"1"}}),_c('rect',{attrs:{"x":"7","y":"7","width":"7","height":"7","rx":"1","stroke":"#8F7A61","stroke-width":"1.5"}})])
          )
        }
      }
    